import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { CompanyList } from './components/CompanyList'
import { MetersList } from './components/MetersList'
import { SitesList } from './components/SitesList'
import DocumentTitle from 'react-document-title'
import { NotesList } from './components/NotesList'
import { useAuth } from '../auth/core/AuthProvider'

const companiesBreadCrumbs: Array<PageLink> = [
  {
    title: 'Company',
    path: '/company/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CompanyPage = () => {
  const { user } = useAuth()
  const canManageCompanyData = user?.permissions?.canManageCompanyData ?? false
  const canManageSiteData = user?.permissions?.canManageSiteData ?? false
  const defaultPath = canManageCompanyData ? '/company/list' : '/company/sites'

  return (
    <Routes>
      <Route element={<Outlet />}>
        {canManageCompanyData && (
          <Route
            path='list'
            element={
              <>
                <DocumentTitle title={process.env.REACT_APP_NAME + ' | Companies'}></DocumentTitle>
                <PageTitle breadcrumbs={companiesBreadCrumbs}>Companies</PageTitle>
                <CompanyList />
              </>
            }
          />
        )}
        {canManageSiteData && (
          <>
            <Route
              path='sites'
              element={
                <>
                  <DocumentTitle title={process.env.REACT_APP_NAME + ' | Sites'}></DocumentTitle>
                  <PageTitle breadcrumbs={companiesBreadCrumbs}>Sites</PageTitle>
                  <SitesList />
                </>
              }
            />
            <Route
              path='meters'
              element={
                <>
                  <DocumentTitle title={process.env.REACT_APP_NAME + ' | Meters'}></DocumentTitle>
                  <PageTitle breadcrumbs={companiesBreadCrumbs}>Meters</PageTitle>
                  <MetersList />
                </>
              }
            />
          </>
        )}
        {canManageCompanyData && (
          <Route
            path='notes'
            element={
              <>
                <DocumentTitle title={process.env.REACT_APP_NAME + ' | Notes'}></DocumentTitle>
                <PageTitle breadcrumbs={companiesBreadCrumbs}>Notes</PageTitle>
                <NotesList />
              </>
            }
          />
        )}
        <Route index element={<Navigate to={defaultPath} />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export default CompanyPage
